/**
 * Shared utility for formatting data in export operations
 * Used by various export mappers to maintain consistent formatting
 */
export class ExportFormatterUtil {
  /**
   * Format a date value for export
   * Handles Date objects, date strings, and invalid values
   */
  static formatDate(date: any): string {
    if (!date) return '';

    if (date instanceof Date) {
      return date.toLocaleDateString();
    }

    if (typeof date === 'string') {
      const parsedDate = new Date(date);
      return isNaN(parsedDate.getTime())
        ? date
        : parsedDate.toLocaleDateString();
    }

    return String(date);
  }

  /**
   * Format a currency value for export
   * Handles numbers, string currency values, and invalid values
   */
  static formatCurrency(value: any): string {
    if (value === null || value === undefined || value === '') return '';

    // Handle numeric values
    if (typeof value === 'number') {
      return `$${value.toFixed(2)}`;
    }

    // Handle string values that may already have currency formatting
    if (typeof value === 'string') {
      // Try to parse it as a number
      const cleaned = value.replace(/[$,]/g, '');
      const num = parseFloat(cleaned);
      if (!isNaN(num)) {
        return `$${num.toFixed(2)}`;
      }
      return value;
    }

    return String(value);
  }
}
